import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Messaging, getToken, isSupported } from '@angular/fire/messaging';
import { first, from, map, of, switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { appQuery, AppState } from '@shared/state';

@Injectable({ providedIn: 'root' })
export class FcmNotificationsService {
  localStorageFlagKey = 'hide-fcm-notification-modal';

  constructor(
    private _http: HttpClient,
    @Optional() private _messaging: Messaging,
    private _appStore: Store<AppState>
  ) {}

  setModalShownFlag() {
    localStorage.setItem(this.localStorageFlagKey, Date.now().toString());
  }

  /**
   * We should only display the modal to the user if the flag is not set in LocalStorage.
   */
  shouldDisplayModal() {
    const localStorageCheck = localStorage.getItem(this.localStorageFlagKey) === null;

    if (!localStorageCheck) {
      return of(false);
    }

    return this._appStore.pipe(
      select(appQuery.getListing),
      first(),
      map(listing => {
        return listing.status === 1;
      })
    );
  }

  /**
   * @todo Add analytics to determine if users are getting to the native permission
   * dialog and hitting yes or no.
   */
  registerForNotifications() {
    return this.getFirebaseToken().pipe(
      first(),
      switchMap(token => this.saveTokenToDB(token))
    );
  }

  private getFirebaseToken() {
    return from(
      isSupported().then(supported => {
        if (!supported || !this._messaging) {
          return Promise.reject(new Error('Firebase Messaging is not supported in this browser'));
        }
        return getToken(this._messaging, { vapidKey: environment.vapidPublicKey });
      })
    );
  }

  private saveTokenToDB(token: string) {
    return this._http.post(
      `${environment.supplierApiGateway}/sup/notification/registration-token`,
      { token },
      {
        headers: {
          'Content-Type': 'application/ate.organiser.v1+json'
        }
      }
    );
  }
}
